<template>
    <div class="todo-footer__tab todo-footer__tab--desktop">
       <button class="todo-footer__tab__btn todo-footer__tab__btn--active"
          @click="allBtnClick"
          ref="allBtn"
        >All</button>
       <button class="todo-footer__tab__btn" 
          @click="activeBtnClick"
          ref="activeBtn"
        >Active</button>
       <button class="todo-footer__tab__btn" 
          @click="completedBtnClick"
          ref="completedBtn"
        >Completed</button>
    </div>
</template>

<script>
export default {
    name: "TheFooterTabsDesktop",
    methods: {
        allBtnClick: function(e) {
            e.target.classList.add('todo-footer__tab__btn--active')
            this.$refs.activeBtn.classList.remove('todo-footer__tab__btn--active')
            this.$refs.completedBtn.classList.remove('todo-footer__tab__btn--active')
            this.$emit('all-todos')
        },
        activeBtnClick: function(e) {
            e.target.classList.add('todo-footer__tab__btn--active')
            this.$refs.allBtn.classList.remove('todo-footer__tab__btn--active')
            this.$refs.completedBtn.classList.remove('todo-footer__tab__btn--active')
            this.$emit('active-todos')
        },
        completedBtnClick: function(e) {
            e.target.classList.add('todo-footer__tab__btn--active')
            this.$refs.allBtn.classList.remove('todo-footer__tab__btn--active')
            this.$refs.activeBtn.classList.remove('todo-footer__tab__btn--active')
            this.$emit('completed-todos')
        }
    },
}
</script>

<style>

.todo-footer__tab__btn {
    height: var(--todo-footer-height);
    background-color: transparent;
    border: none;
    transition: color 250ms;
    font-size: inherit;
    color: var(--todo-footer-clr);
    white-space: nowrap;
    font-weight: 700;
    padding: 0 10px
}

.todo-footer__tab__btn:not(.todo-footer__tab__btn--active):hover,
.todo-footer__clear-completed-btn:hover { 
    color: var(--todo-footer-hover-clr);
}

.todo-footer__tab__btn--active { color: var(--todo-footer-btn-active) }

.todo-footer__tab__btn:focus {
    outline: solid 1.5px var(--todo-border-clr);
    height: calc(var(--todo-footer-height) - 3px);
    padding: 0 10px; /* yes. I know it's bad. Affects performance */
}
 
@media screen and (max-width: 33.125em) { /* 530px */
    .todo-footer__tab--desktop { display: none }
}

</style>